import React, { useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlineHome } from "react-icons/hi2";

function formatPrice(val) {
  return "₹" + Number(val).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export default function Predictor() {
  const [form, setForm] = useState({ space: "", rooms: "", floors: "", location: "urban" });
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function update(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError(null);
  }

  async function predict() {
    if (!form.space || !form.rooms || !form.floors) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);
    setError(null);
    setPrice(null);

    try {
      const { data } = await axios.post(
        "https://house-price-predictor-gtoo.onrender.com/predict",
        {
          space: Number(form.space),
          rooms: Number(form.rooms),
          floors: Number(form.floors),
          location: form.location,
        }
      );
      setPrice(data.predicted_price);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page">
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="card-header">
          <div className="icon-box">
            <HiOutlineHome />
          </div>
          <h1>AI House Price Predictor</h1>
          <p>Get instant price predictions using Machine Learning</p>
        </div>

        <div className="fields">
          <div className="field">
            <label>Space (sq ft)</label>
            <input type="number" name="space" placeholder="1200" value={form.space} onChange={update} />
          </div>
          <div className="field">
            <label>Rooms</label>
            <input type="number" name="rooms" placeholder="3" value={form.rooms} onChange={update} />
          </div>
          <div className="field">
            <label>Floors</label>
            <input type="number" name="floors" placeholder="2" value={form.floors} onChange={update} />
          </div>
          <div className="field">
            <label>Location</label>
            <select name="location" value={form.location} onChange={update}>
              <option value="urban">Urban</option>
              <option value="rural">Rural</option>
            </select>
          </div>
        </div>

        <button className="predict-btn" onClick={predict} disabled={loading}>
          {loading ? <><div className="spinner" /> Predicting...</> : "Predict Price"}
        </button>

        {error && (
          <div className="error-msg">
            <span>{error}</span>
            <button className="dismiss" onClick={() => setError(null)}>✕</button>
          </div>
        )}

        <AnimatePresence>
          {price !== null && (
            <motion.div
              className="result"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35 }}
            >
              <div className="label">Estimated Price</div>
              <div className="price">{formatPrice(price)}</div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      <div className="footer-text">
        Built with React + FastAPI + Machine Learning
      </div>
    </div>
  );
}
